export const truncateText = (text: string, maxLength: number = 24): string => {
  return text.length > maxLength ? `${text.slice(0, maxLength)}...` : text
}

export const obtenerDescripcionPorId = (id: number): string | undefined => {
  const storedData = localStorage.getItem('dataLocalizacion')

  if (storedData) {
    const parsedData = JSON.parse(storedData)

    const localizacion = parsedData.find(
      (item: {IdLocalizacion: number}) => item.IdLocalizacion === id
    )
    if (localizacion) {
      return localizacion.Descripcion
    }
  }

  return undefined
}
